<template>
  <v-sheet class="p-4">
    <div v-html="content.content" />
  </v-sheet>
</template>
<script>

import { mapGetters } from 'vuex';
import timeHandlerMIxin from './timeHandlerMIxin';

export default {
  mixins: [timeHandlerMIxin],
  computed:{
    ...mapGetters(['content']),
  }
}
</script>
<style>
  iframe {
    width: 100%;
  }
</style>
<style scoped>
iframe{
  height: 100%;
}
</style>
